import React from "react";
import NoMatch from "../NoMatch";
import {
    BrowserRouter,
    Route,
    Routes,
    useParams,
    useLocation,
    Outlet,
} from "react-router-dom";
import { isUUID } from "../../utils";
import {
    useHasCapabilities,
} from "../../hooks";
import withReducers from "../../store/withReducers";
import workflowAutomationsSlice from "../../redux/workflowAutomations";
import AutomationsPage from "./automations-page/AutomationsPage";
import AutomationEditorPage from "./editor-page/AutomationEditorPage";

export const WORKFLOW_AUTOMATIONS_CAPABILITIES = "HAS-WORKFLOW-AUTOMATION";
export const MODIFY_WORKFLOW_AUTOMATION_CAPABILITY_NAME = "MODIFY-WORKFLOW-AUTOMATION";

const useHasWorkflowAutomationsAccess = (): boolean => {
    const hasCapabilities = useHasCapabilities(WORKFLOW_AUTOMATIONS_CAPABILITIES, true);
    return hasCapabilities;
};

const NoMatchWrapper = () => {
    const location = useLocation();
    return <NoMatch location={location} />;
};

const AccessGate = () => {
    const hasAccess = useHasWorkflowAutomationsAccess();
    const location = useLocation();
    const { workflowId } = useParams();

    if (!hasAccess) {
        throw new Error("Unauthorized to access automations");
    }

    if (location.pathname === `/automations/${workflowId}` && !isUUID(workflowId)) {
        return <NoMatch location={location} />;
    }
    return <Outlet />;
};

const WorkflowEditorAccessGate = () => {
    const canEdit = useHasCapabilities("MODIFY-WORKFLOW-AUTOMATION");

    if (!canEdit) {
        throw new Error("Unauthorized to access the automation editor");
    }

    return <Outlet />;
};

const WorkflowAutomationsRouter = ({ basename }: { basename?: string }) => {
    return (
        <BrowserRouter basename={basename}>
            <Routes>
                <Route element={<AccessGate />}>
                    <Route
                        path="/automations"
                        element={<AutomationsPage />}
                    />
                    <Route element={<WorkflowEditorAccessGate />}>
                        <Route
                            path="/automations/:workflowId"
                            element={<AutomationEditorPage />}
                        />
                    </Route>
                    <Route
                        path={"*"}
                        element={<NoMatchWrapper />}
                    />
                </Route>
            </Routes>
        </BrowserRouter>
    );
};

export default withReducers(WorkflowAutomationsRouter, {
    [workflowAutomationsSlice.name]: workflowAutomationsSlice.reducer,
});
